import allyLogo from "@icons/institutions/ally.png";
import bmoLogo from "@icons/institutions/bmo.png";
import citizensBankLogo from "@icons/institutions/citizens-bank.png";
import digitsLogo from "@icons/institutions/digits.png";
import discoverLogo from "@icons/institutions/discover.png";
import fifthThirdBankLogo from "@icons/institutions/fifth-third-bank.png";
import freshbooksLogo from "@icons/institutions/freshbooks.png";
import goldmanSachsLogo from "@icons/institutions/goldman-sachs.png";
import hsbcLogo from "@icons/institutions/hsbc.png";
import huntingtonBankLogo from "@icons/institutions/huntington-bank.png";
import keybankLogo from "@icons/institutions/keybank.png";
import morganStanleyLogo from "@icons/institutions/morgan-stanley.png";
import mtBankLogo from "@icons/institutions/mt-bank.png";
import puzzleLogo from "@icons/institutions/puzzle.png";
import regionsBankLogo from "@icons/institutions/regions-bank.png";
import siliconValleyBankLogo from "@icons/institutions/silicon-valley-bank.png";
import truistLogo from "@icons/institutions/truist.png";
import usBankLogo from "@icons/institutions/us-bank.png";
import xeroLogo from "@icons/institutions/xero.png";
import type { InstitutionArtwork } from "./institutionArtwork";

/**
 * Brands the product shows that Figma does not draw yet (spec I6, question
 * D5), with today's artwork.
 */
export const productInstitutions = {
    ally: { name: "Ally", glyph: { src: allyLogo } },
    bmo: { name: "BMO", glyph: { src: bmoLogo } },
    "citizens-bank": {
        name: "Citizens Bank",
        glyph: { src: citizensBankLogo },
    },
    discover: { name: "Discover", glyph: { src: discoverLogo } },
    "fifth-third-bank": {
        name: "Fifth Third Bank",
        glyph: { src: fifthThirdBankLogo },
    },
    "goldman-sachs": {
        name: "Goldman Sachs",
        glyph: { src: goldmanSachsLogo },
    },
    hsbc: { name: "HSBC", glyph: { src: hsbcLogo } },
    "huntington-bank": {
        name: "Huntington Bank",
        glyph: { src: huntingtonBankLogo },
    },
    keybank: { name: "KeyBank", glyph: { src: keybankLogo } },
    "morgan-stanley": {
        name: "Morgan Stanley",
        glyph: { src: morganStanleyLogo },
    },
    "mt-bank": { name: "M&T Bank", glyph: { src: mtBankLogo } },
    "regions-bank": { name: "Regions Bank", glyph: { src: regionsBankLogo } },
    "silicon-valley-bank": {
        name: "Silicon Valley Bank",
        glyph: { src: siliconValleyBankLogo },
    },
    truist: { name: "Truist", glyph: { src: truistLogo } },
    "us-bank": { name: "US Bank", glyph: { src: usBankLogo } },
    xero: { name: "Xero", glyph: { src: xeroLogo } },
    digits: { name: "Digits", glyph: { src: digitsLogo } },
    puzzle: { name: "Puzzle", glyph: { src: puzzleLogo } },
    freshbooks: {
        name: "Freshbooks",
        background: "var(--color-white)",
        glyph: { src: freshbooksLogo },
        box: { x: 4, y: 16.38, width: 32, height: 7.23 },
    },
} satisfies Record<string, InstitutionArtwork>;
